import { Offer } from "src/types/Offer";

export const offerIsExpired = (offer: Offer) => {
  return offer.expires_at && new Date(offer.expires_at) < new Date();
};
;
import "/Users/igor/Duffel/ancillaries-component/node_modules/@sentry/bundler-plugin-core/sentry-release-injection-file.js";